(function() {
'use strict';

angular.module('TR')
    .directive('staticMap', staticMap);

function staticMap(googleStaticMap, $window, $timeout) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            lon: '=',
            lat: '=',
            width: '@',
            height: '@',
            zoom: '=?',
            click: '&?',
            showMarker: '@?',
            class: '@?',
            responsive: '@?'
        },
        template() {
            return '<div class="google-map" gtm-namespace="google-map" ng-transclude ng-style="{\'background-image\' : \'url(\' + mapUrl + \')\'}" ng-click="click()" ng-class="{clickable: click !== null}" ></div>';
        },
        transclude: true,
        link(scope, element) {
            scope.$watch('lon', function(v) {
                if (v == null) {
                    return;
                }
                init();
            });
           function init() {
                if (TRPCONFIG.IsBot) { return; }

                function loadMapLazy() {
                    if (!scope.responsive) {
                        scope.width *= 1.5;
                        scope.height *= 1.5;
                    }

                    const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap?';

                    const zoom = `zoom=${scope.zoom || 15}`;
                    const center = `&center=${encodeURIComponent(`${scope.lat},${scope.lon}`)}`;
                    const size = `&size=${scope.width}x${scope.height}`;
                    const markers = `&markers=${encodeURIComponent(`${scope.lat},${scope.lon}`)}`;
                    const client = '&client=gme-travelrepublic';


                    let url = baseUrl + zoom + center + size + client;

                    if (scope.showMarker) {
                        url += url.concat(markers);
                    }

                    scope.mapUrl = '';
                    googleStaticMap.getStaticMapUrl(url)
                        .then(data => {
                            $timeout(() => scope.mapUrl = data);
                        });
                }

                let win = $($window);

                function isScrolledIntoView(elem) {
                    let docViewTop = win.scrollTop();
                    let docViewBottom = docViewTop + win.height();

                    let elemTop = elem.offset().top;
                    let elemBottom = elemTop + elem.height();
                    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
                }
                let deb = _.debounce(() => {
                    let el = $(element);

                    if (!isScrolledIntoView(el)) {
                        return false;
                    }

                    win.off('scroll', deb);
                    loadMapLazy();
                }, 100);

                deb();
                win.on('scroll', deb);
            }
        }

    };
}
})();
